export enum UserRoutingEnum {
  PROFILE = "profile",
  UPDATE_INFOR = "update-information",
  CHANGE_PASS = "change-password",
  NOTIFICATION = "notification",
}
